/**
 * @generated SignedSource<<382309dae3590b7be0c7b83c5be1694f>>
 * @relayHash 5e10dafc54e9f48d721a8524fe5008c2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d7c0b4a35ffd09186c0c4c17c9ee0039ae2721066b34a5d8ffb7f41e6e8263e2

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { src_jiraBoardEmbedQuery } from './src_jiraBoardEmbedQuery.graphql';

const node: PreloadableConcreteRequest<src_jiraBoardEmbedQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "d7c0b4a35ffd09186c0c4c17c9ee0039ae2721066b34a5d8ffb7f41e6e8263e2",
    "metadata": {},
    "name": "src_jiraBoardEmbedQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
